import { CenterAligned, FlexColumn } from "@opensea/ui-kit"
import React from "react"
import { Modal } from "@/design-system/Modal"
import { Text } from "@/design-system/Text"

type Props = {
  heading: string
  body?: string
  icon: React.ReactNode
  children?: React.ReactNode
}

export function ManageSmsModalBody({ heading, body, icon, children }: Props) {
  return (
    <Modal.Body className="flex flex-1 flex-col px-6 pb-4 pt-10">
      <FlexColumn className="h-full items-center gap-8 text-center">
        <CenterAligned className="size-[100px] rounded-xl bg-component-gray-1">
          {icon}
        </CenterAligned>

        <FlexColumn className="items-center gap-2">
          <Text.Heading size="medium">{heading}</Text.Heading>
          {body ? (
            <Text.Body color="gray-2" weight="semibold">
              {body}
            </Text.Body>
          ) : null}
        </FlexColumn>
        {children}
      </FlexColumn>
    </Modal.Body>
  )
}
